import { useViewport } from 'hooks/3catinfo/useViewport';
import DestacatBasic from './DestacatBasic';
import DestacatDirecte from './DestacatDirecte';
import DestacatDtyDestacat from './DestacatDtyDestacat';
import DestacatHoritzontal from './DestacatHoritzontal/DestacatHoritzontal';
import DestacatMinut from './DestacatMinut/DestacatMinut';
import DestacatNoticiaAutor from './DestacatNoticiaAutor';
import DestacatRankingHoritzontal from './DestacatRanking/DestacatRankingHoritzontal';
import DestacatUltimaNoticia from './DestacatUltimaNoticia';
import DestacatVisual from './DestacatVisual';
import DestacatVisualMinut from './DestacatVisualMinut/DestacatVisualMinut';
import DestacatText from './DestacatText/DestacatText';
import DestacatMedia from './DestacatMedia';
import __isEmpty from 'lodash/isEmpty';

export default function Component(props) {
    const { format, tipologia, redlAuxInfo, numColumnsRow, marcatgeAudiencies, index } = props;
    let { formatMobile } = props;
    const { isMobile } = useViewport();

    const redlInfo = redlAuxInfo?.split('|');
    const indexDestacat = parseInt(redlInfo?.[1]);
    const indexRedl = parseInt(redlInfo?.[3]);
    const infoBlocRedl = props.infoBlocRedl || marcatgeAudiencies;
    const indexMarcatge = index || 1;
    const marcatgeAudienciesClick = infoBlocRedl
        ? `Tira:${indexMarcatge}:${infoBlocRedl?.descripcio ? infoBlocRedl?.descripcio?.replace(':', '.') : ''}`
        : '';
    if (tipologia === 'DEBAT_MINUTAMINU') {
        if ((!__isEmpty(props.directes) && props.playerEmbedat === true) || format !== 'visualMinut') {
            return <DestacatMinut {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        }
        return <DestacatVisualMinut {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
    }
    if (tipologia === 'DTY_DESTACAT') {
        return <DestacatDtyDestacat {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
    }

    if (isMobile && numColumnsRow > 4 && (format === 'basic' || __isEmpty(format)) && indexDestacat === 1 && indexRedl === 1) {
        formatMobile = formatMobile || 'visualNoticia';
    }

    const formatDestacat = !isMobile ? format : formatMobile || format;

    switch (formatDestacat) {
        case 'rankingHoritzontal':
            return <DestacatRankingHoritzontal {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        case 'horitzontal':
            return <DestacatHoritzontal {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        case 'directes':
            return <DestacatDirecte {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        case 'noticiaAutor':
            return <DestacatNoticiaAutor {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        case 'ultimaNoticia':
            return <DestacatUltimaNoticia {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        case 'minutaminut':
            return (
                <DestacatBasic
                    {...props}
                    marcatgeAudienciesClick={marcatgeAudienciesClick}
                    routePath='web_actualitat_item_minutaminut'
                    mostrarData={true}
                />
            );
        case 'minutaminut_horitzontal':
            return (
                <DestacatHoritzontal
                    {...props}
                    marcatgeAudienciesClick={marcatgeAudienciesClick}
                    routePath='web_actualitat_item_minutaminut'
                    mostrarData={true}
                />
            );
        case 'visualNoticia':
            return <DestacatVisual {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        case 'visualMinut':
            return <DestacatVisualMinut {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
        case 'text':
            return <DestacatText {...props} />;
        case 'media':
            return <DestacatMedia {...props} />;
        default:
            return <DestacatBasic {...props} marcatgeAudienciesClick={marcatgeAudienciesClick} />;
    }
}
